import React, { useState, FormEvent, useEffect, WheelEventHandler } from 'react';
import { useParams } from 'react-router-dom';

import {Suggest2, Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation ,Icon} from "@blueprintjs/core";
//import { DateInput3 } from "@blueprintjs/datetime2";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';
import svgWait2 from './svg/wait2.gif'
import {  StkRecordinfo} from './Types'
import { SystemHeader } from './CommonUI';
import i18next from 'i18next';
import { access } from 'fs';

import svgcaretdown from './svg/caret-down.svg'

interface PageInfo {
    n: number
}

interface PageInfo2 {
    pageno: number,
    pageShow: boolean,
    pageStartno: number,
    pageEndno: number,
    pageLast: boolean,
}


var GsbFlag: any;

var UserID: string;
var PgmCode = "H0025" ;
var isReqAuth2:boolean = false ;
 
interface StkRecordDateViewProps {
    gsb: AxiosInstance,
    Stk: StkRecordinfo,
    Stk0: StkRecordinfo,    
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onReplicate?: () => void,  
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
    PgmMode:any,    
}


function StkRecordDateView({ gsb, Stk = {} as StkRecordinfo,Stk0 = {} as StkRecordinfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 ,PgmMode}: StkRecordDateViewProps) {
    const { t, i18n } = useTranslation();       
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)
    const [isCanDelete, setisCanDelete] = useState(true)
    const [isDeletePress2, setisDeletePress2] = useState(false)
 

    const [isOpenDialog, setisOpenDialog] = useState(false)
    const [isOPenAlert, setisOPenAlert] = useState(false)
    const [cAction, setcAction] = useState("")
    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")


    const [AcStatusValue, setAcStatusValue] = useState("")
 

    //Listed cannnot ammmed
    const [MailListStatusValue,setMailListStatisValue] = useState(false)

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    const [d_RebateRate,setd_RebateRate ] =useState("") //useState ((utils.ParseFloat(Mail.d_RebateRate,4)).toString())



    const [showSIMore, setshowSIMore] = useState(true)

 
     const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("StkRecordDateView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, Stk])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


 


 

 
  if (! ("d_StkNo" in Stk)) return null 

    const AcNOToolTip = 
    <div>
        <div>Stk No. </div>
        <div>Cash A/C : ACCOUNT=Axxxx, CUSTODY=Pxxxx </div> 
        <div>Margin A/C : MARGIN=Mxxxx </div> 
        <div>RUNNER=Cxxxx, INTERNAL=Ixxxx </div> Stock No. cannot be Blank
   </div>

  
    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
          
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true)} >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                {/* <Button className="Col-7-2" icon="document" onClick={() => { window.open(`/#/BookClosedQty?Stkno=${Mail.d_StkNo}?IPONo=${Mail.d_IPONo}`, '_blank') } } >Book Closed Qty</Button> */}
            </div>
            <div className="Spacing-V-16" />
           <div className="Row">
                <FormGroup className="Col-1-4" label="Stock No."> 
                  <InputGroup readOnly value={Stk.d_StkNo} />
                </FormGroup>
            </div>
               
            <div className="Row">                
                <FormGroup className="Col-1-4" label="Stock Code">
                    <InputGroup readOnly value={Stk.d_StkCode} /> 

                </FormGroup>               
            </div>
               
            <div className="Row">                
                <FormGroup className="Col-1-4" label="Stock Name">
                    <InputGroup readOnly value={Stk.d_StkName} />
                </FormGroup>               
            </div>
           
 
            <div className="Spacing-V-16"></div>
 {/*
      <FormGroup className="Col-3-2" label="Warrant/Rights Expiry Date">
                    <InputGroup readOnly value={utils.dispDate(stk.d_ExpiryDate, GsbFlag.dateFormat)} />
                </FormGroup>
 */}
                        <div className="Row">
            <FormGroup className="Col-1-2" label={t('Stock Record Date')} labelFor="inputStkRecord_Date">
                <InputGroup readOnly value= {utils.dispDate(Stk.d_StkRecordDate, GsbFlag.dateFormat)} />
               
            </FormGroup>

 
            </div>
            <br></br>
           
 
   
        </div>
    )
}

interface StkRecordDateEditProps {
    gsb: AxiosInstance,
    Stk?: StkRecordinfo,  
    isNew?: boolean,
    onSave?: (stk: StkRecordinfo) => void,
    onCancel?: () => void,
    PgmMode: any,    
}


function StkRecordDateEdit({ gsb, Stk = {} as StkRecordinfo,  isNew = false, onSave = () => { }, onCancel = () => { } ,PgmMode}: StkRecordDateEditProps) {

    const [isReqAuth, setisReqAuth] = useState(false)    
    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<StkRecordinfo>()
    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();       
 
   // const [AcCodeValue, setAcCodeValue] = useState(Mail.d_acCode)
   // const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
   // const [AcCodeList, setAcCodeList] = useState([] as AcCodeInfo[])
 

    const [searchStk,setsearchStk] = useState("")    
    const [CurrencyValue,setCurrencyValue] = useState("")
   // const [def_d_acCode ,setdef_d_acCode] = useState (Mail.d_acCode)
 
 
    
    const [AcStatusValue, setAcStatusValue] = useState("")
 
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [showChannel, setshowChannel] = useState(false)
    const [showMULTI_PRCE, setshowMULTI_PRCE] = useState(false)
    

    

    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                // setuserKey(GsbFlag.user_key)
                // setGSBx_USER(GsbFlag.GSBx_USER) ;
                // setdateFormat(GsbFlag.dateFormat)
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb])  

 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

                setshowChannel( GsbFlag.MULTI_CHNL ) ;
                setshowMULTI_PRCE( GsbFlag.MULTI_PRCE ) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])  

        useEffect(() => {
        // Call reset to get the values of record StkInfo 
        if ("d_StkNo" in Stk) {
            reset(Stk)
        }
    }, [Stk, reset])
 
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
     
    
    if (! isNew && ! ("d_StkNo" in Stk)) return null

    const onSubmit = (data: StkRecordinfo) => {
 
        if ( typeof(data.d_StkRecordDate) === "undefined" ) {
            data.d_StkRecordDate = "  -  -    "
        }

        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }
        
        ;

        (async () => {
            try {
                //console.log("call smmastedit data", data)
                //console.log("call smmastedit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CCRStkRecord", cAction: "Validate", isNew: isNew})
                //console.log("smmastedit res.data.ok", res.data.ok)
                //console.log("smmastedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    } 
                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
        
    }
    

       
    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }
       
    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
       
       
    const handleViewInfoClick = (event: any): void => {
        event.preventDefault()    
        
        } 

    
    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
           
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>

            </div>
     
            <div className="Spacing-V-16" />

            <div className="Row">
                <FormGroup className="Col-1-4" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                    <InputGroup disabled={true} id="inputStkNo" name="d_StkNo"   autoFocus={isNew} defaultValue="" inputRef={register({ required: true }) } />
     
                </FormGroup>
            </div>
               
            <div className="Row">                
                <FormGroup className="Col-1-4" label="Stock Code" labelFor="inputStkCode" labelInfo="*">
                    <InputGroup id="inputStkCode" name="d_StkCode" disabled={true} autoFocus={! isNew} defaultValue="" placeholder="Stock Code is 15 chars ..." inputRef={register({ required: true  }) } />

                </FormGroup>       
            </div>
               
            <div className="Row">                
                <FormGroup className="Col-1-4" label="Stock Name" labelFor="inputStkName">
                    <InputGroup id="inputStkName" name="d_StkName" defaultValue={Stk.d_StkName}  disabled={true} placeholder="Stock Name ..." inputRef={register({ maxLength: 45}) } />

                </FormGroup>          
            </div>
           
 
            <div className="Spacing-V-16"></div>
 
            <div className="Row">
                <FormGroup className="Col-1-2" label={t('Stock Record Date')} labelFor="inputStkRecord_Date">
                   <InputGroup id="inputStkRecord_Date" name="d_StkRecordDate" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                   {errors.d_StkRecordDate && errors.d_StkRecordDate.types && <span id="Err_msg">{errors.d_StkRecordDate.types.message}</span>}
                </FormGroup>

            </div>
        
     
 
        </form>
    )
}

interface StkRecordDateMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function StkRecordDateMain({ gsb }: StkRecordDateMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "" }: { acCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 
 
    const [data, setData] = useState([] as StkRecordinfo[])
    
 
    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchStkName, setsearchStkName] = useState("")
    const [searchApplyDate, setsearchApplyDate] = useState("")

 
 
    const [searchStockRecordDate, setsearchStockRecordDate] = useState("")

 
    const [showFilters, setShowFilters] = useState(false)

 
    const [s_AcStatus, sets_AcStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as StkRecordinfo)
    const [currentAc2, setCurrentAc2] = useState({} as StkRecordinfo)


    //MailInfo
    const [BlankAc, setBlankAc] = useState({} as StkRecordinfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as StkRecordinfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as StkRecordinfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
    
    const [showCurrency, setshowCurrency] = useState(false)
    const { t, i18n } = useTranslation();
 

    BlankAc.d_StkNo =""
    BlankAc.d_StkName =""
    BlankAc.d_AuthTran = "N"
    BlankAc.d_StkCode =""
    BlankAc.d_StkRecordDate ="    -  -  "
     useEffect(() => {
         (async () => {
             try {
                 // get GsbFlag from SB.XBS
                 const res = await gsb.post('/GsbFlag');
                 //console.log("PayRecTranEntryMain disp user_key: ", res.data.Flag.user_key)
                 //console.log("PayRecTranEntryMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                 //console.log("PayRecTranEntryMain disp data.Flag: ", res.data.Flag)
                 GsbFlag = res.data.Flag;
                 //console.log("PayRecTranEntryMain disp GsbFlag: ", GsbFlag)
                 //console.log("PayRecTranEntryMain disp GsbFlag.lang: ", GsbFlag.lang)
                 //console.log("PayRecTranEntryMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                 console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                 //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                 UserID = res.data.Flag.UserID
                 //console.log("PayRecTranEntryMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                 //console.log("PayRecTranEntryMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                 //console.log("PayRecTranEntryMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                 setCO_NAME( GsbFlag.CO_NAME) ;
                 setcompanyLogoName( GsbFlag.companyLogoName) ;
                 setSBPath( GsbFlag.SBPath) ;
                 setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                 setSETL_DATE(GsbFlag.SETL_DATE ) ;
                 if ( GsbFlag.isProduction == "Y" ) {
                     setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                 } else {
                     setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                 }
 
                 setshowCurrency( (GsbFlag.MULTI_MKT) && ( ! GsbFlag.SING_CURR) );
              
             } catch (error) {
                 utils.showError(error)
             }
         })()
     }, [gsb])

  


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');        
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
             
                UserID = res.data.Flag.UserID  
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSUSPEND_AC(GsbFlag.SUSPEND_AC);

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

 
    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("StkRecordDateMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            //setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])

/*
    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }
        
        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "CCRStkRecord", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("StkRecordDateMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
 */
 

    const PrevRecProcess = async (Stk: StkRecordinfo) => {
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: Stk, cPgmId: "CCRStkRecord", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }
 
   
  
    const DeleteProcess = async (Stk: StkRecordinfo) => {
        try {
            Stk.d_AuthTran = ""
            if (isReqAuth2) {
                Stk.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/Master', {sb_data: Stk, cPgmId: "CCRStkRecord", cAction: "DelRec"})
            if (res.data.ok) {
                if (isReqAuth2) {
                    showSuccess("Account No. " + Stk.d_StkNo +" record deleting, waiting for authorization")
                } else {
                    showSuccess("Account No. " + Stk.d_StkNo +" record deleted")
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].d_StkNo === res.data.data.d_acCod_StkNode) {
                            data[i] = { ...data[i], ...res.data.data }
                            setData(data)
                            break
                        }
                    }
                }
                setCurrentAc(res.data.data)               
                setCurrentMode("show")
                if (isReqAuth2) {
                    alert("Account No. " + Stk.d_StkNo +"  record deleting, waiting for authorization")
                }
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (Stk: StkRecordinfo) => {
        try {
            console.log("call NextRecProcess", Stk)
            const res = await gsb.post('/Master', {sb_data: Stk, cPgmId: "CCRStkRecord", cAction: "NextRec"})
            //console.log("NextRecProcess show 1: ", stk.d_StkNo)
            console.log("NextRecProcess data : ", data)
            console.log("NextRecProcess res.data : ", res.data.data)
                //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentAc(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (Stk: StkRecordinfo) => {
        try {


           
            //console.log("call newOnSave", Mail)
            const res1 = await gsb.post('/GsbFlag');
            //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;
            


            //console.log("MenuBar disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
            const res = await gsb.post('/Master', {sb_data: Stk, cPgmId: "CCRStkRecord", cAction: "AddRec"})
            if (isReqAuth2) {
                showSuccess(" Account No. [" + Stk.d_StkNo + "] record adding, waiting for authorization")
            } else {
                showSuccess(" Account No. [" + Stk.d_StkNo + "] record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        data[i] = { ...data[i], ...res.data.data }
                    
                        setData(data)
                        break
                    }
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                alert(" Account No. [" + Stk.d_StkNo + "] record adding, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
           
        }
    }


  const editOnSave = async (stk: StkRecordinfo) => {
        try {
            //console.log("call editOnSave", stk)
            //console.log("stk.d_CcassStk: ", stk.d_CcassStk)
            const res = await gsb.post('/Master', {sb_data: stk, cPgmId: "CCRStkRecord", cAction: "UpdateRec"})
            if (isReqAuth2) {
                showSuccess("Stock No. " + stk.d_StkNo + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        setCurrentAc(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                alert("Stock No. " + stk.d_StkNo + " record saving, waiting for authorization")
            } else {
                showSuccess("Stock No. " + stk.d_StkNo + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        //setCurrentStk(stk)
                        break
                    }
                }
                //console.log("editOnSave stk", stk)
                //console.log("editOnSave res.data.data", res.data.data)
                setCurrentAc(res.data.data)
                setCurrentMode("show")
                //setisShowAlert1(true)
                //setShowAlert1Msg("Account No. " +ac.d_acCode + " record saved")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
       // setnTotalPage(0)
       // setPageReachEnd(false)

        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        try {
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            StkName: searchStkName,
                            SearchRecordDate:searchStockRecordDate,
                        }, 
                    },
                    cPgmId: "CCRStkRecord",
                    cAction: "ListRec",
                });


                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_StkNo: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CCRStkRecord",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }
            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

   //Press page No 1 2 3 4
      useEffect(() => {
          if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
      
              setShowWait(true)
              if ( nPage > 0 ) {
                  //setcPrintMode("S")
              } 
      
              (async () => {
                  try {
                      //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                      const res = await gsb.post('/Master',
                      {   sb_data: {
                              by: searchKey,
                              start: searchValue,
                              nPage: nPage,
                              limit: searchLimit,
                              backward: searchBackward,
                              filters: {
                                StkName: searchStkName,
                                SearchRecordDate:searchStockRecordDate,
                              }, 
                          },
                          cPgmId: "CCRStkRecord",
                          cAction: "ListRec",
                      });
  
                      setData(res.data.data)
                      if (res.data.data.length > 0) {
                          setCurrentAc(res.data.data[0])
                      }
                      setShowWait(false)
          
                  } catch (error) {
                      utils.showError(error)
                  }
              })()
          }
      }, [gsb, nPage, selectedTabId])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <StkRecordDateView gsb={gsb} Stk={currentAc} Stk0={currentAc}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="StkRecord" ></StkRecordDateView>
    switch (currentMode) {
       case "new":

            console.error("new" )
            detail = <StkRecordDateEdit gsb={gsb} Stk={BlankAc}   isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } PgmMode="StkRecord" ></StkRecordDateEdit>
            break
        case "edit":
          
            detail = <StkRecordDateEdit gsb={gsb} Stk={currentAc}  onSave={editOnSave} onCancel={() => setCurrentMode("show")} PgmMode="StkRecord" ></StkRecordDateEdit>
            break
 
    }

    let logKeyViewRec = <StkRecordDateView gsb={gsb} Stk={CurrentLog1} Stk0={CurrentLog0}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="StkRecord"  ></StkRecordDateView>

   // let logKeyViewRec = <StkRecordDateView gsb={gsb} Mail={CurrentLog1} Mail0={CurrentLog0}   baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="StkRecord"  ></StkRecordDateView>
    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

 
 
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

    
    let list = <>
        {/*<div className="Row">
            <Button className="Col-1-1" icon="add" disabled={false} onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>*/}
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>                                  
                <th className="TCol-StkCode">Stock No.</th>
                <th className="TCol-StkNo">Stock Code</th>
                <th className="TCol-StkNo">Stock Name</th>
                <th className="TCol-StkNo">Stock Record Date</th>        
        
            </thead>
            <tbody id="ma_tr">
                {data.map((Stk, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>                  
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Stk) ; MoblieDev && setSelectedTabId("detail") }}>{Stk.d_StkNo}</td>                        
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(Stk) ; MoblieDev && setSelectedTabId("detail") }}>{Stk.d_StkCode}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Stk) ; MoblieDev && setSelectedTabId("detail") }}>{Stk.d_StkName}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(Stk) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(Stk.d_StkRecordDate, GsbFlag.dateFormat)}</td>                          
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H4><div style={{justifyContent: 'flex-end'}}>Setup Stock Record Date</div></H4>
                    <div className="Row No-Print">
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>                                   
                                    <option value="StkNo">Stock No</option>
                                    <option value="StkCode">Stock Code</option>
                                                                        
                                    {/* <option value="_recordNo">Record No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "StkNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "StkNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                          
                            <FormGroup className="Col-1-2" label="Search Record Date" labelFor="searchApplyDate">
                               <InputGroup id="searchStockRecordDate"   value={searchStockRecordDate} type ="date"  placeholder="YYYY-MM-DD" onChange={utils.handleStringChange(s => setsearchStockRecordDate(s))} />
                            </FormGroup>
                            {/*
                            <FormGroup className="Col-1-2" label="Stock Code" labelFor="searchStk">
                                <InputGroup id="searchStk" value={searchStk} onChange={utils.handleStringChange(s => setsearchStk(s))} />
                            </FormGroup>
                            <FormGroup className="Col-1-2" label="Stock Name." labelFor="searchStkName">
                                <InputGroup id="searchStkNo" value={searchStkName} onChange={utils.handleStringChange(s => setsearchStkName(s))} />
                            </FormGroup>
                            */}
                        </div>
                    </Collapse>
                  
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Stock Recordr Log View</H3>
                    <div className="Spacing-V-16" />
                    {/*logKeyViewRec*/}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default StkRecordDateMain



